import axios from 'axios'
import urlHelper from './urlHelper'

const baseUrl = urlHelper('/api/book')

export default {
  get (id) {
    return axios.get(`${baseUrl}/${id}`)
  }
}



// WEBPACK FOOTER //
// ./src/api/book.js